<template>
  <div class="wrap">
    <div class="complete join_complete">
      <div class="container">
        <div class="complete_area">
          <div class="img_area">
            <img src="/assets/images/layout/complete_2.png" />
          </div>
          <div class="page_title">회원 탈퇴가 정상적으로 완료되었습니다.</div>
          <div class="txt_area">
            <p class="out">
              지금까지 라온 메타데미를 이용해 주셔서 감사합니다.<br />
              더 나은 서비스와 콘텐츠로 보답할 수 있도록 노력하겠습니다.
            </p>
          </div>
          <div class="btn_area">
            <a href="/" class="btn_basic">메인으로 돌아가기</a>
          </div>
        </div>
      </div>
    </div>
    <div class="floating_top" @click="scrollToTop()">
      <img src="/assets/images/icon/icon-top-button.svg" alt="" />
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { onMounted } from 'vue'
import { useCookies } from 'vue3-cookies'

export default {
  name: 'WithdrawalCompleteMessageViews',
  components: {},
  setup() {
    const instance = axios.create({
      baseURL: process.env.VUE_APP_LMS_URL,
    })
    const { cookies } = useCookies()
    console.log('탈퇴 최종 페이지')

    const workItOpen = async () => {
      console.log('함수 진입')
      const getAccess = cookies.get('access_token')
      const headers = { Authorization: getAccess }
      console.log(getAccess)
      console.log(headers)

      // if (getAccess?.length !== 0) {
      if (getAccess?.length) {
        await instance.post(`/api/v1/member/logout`, null, { headers })
        localStorage.clear()
        cookies.remove('access_token')
        cookies.remove('refresh_token')
        cookies.remove('stayToken')
      } else {
        console.log('비정상적 접근!!!')
      }
    }
    onMounted(() => {
      console.log('탈퇴 최종 페이지의 온마운트 진행')
      workItOpen()
    })
  },
}
</script>
